import * as React from 'react';
import { Component } from 'react';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { MergeSubscriberGroupProps } from './types';
import { LoadOptions } from 'app/types-shared';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { fieldName } from './constants';
import {
  MergeSubscriberGroupSinglePicker
} from 'app/area/subscriber-groups/shared/merge-subscriber-group/merge-subscriber-group-single-picker';
import { validate } from 'app/area/subscriber-groups/shared/merge-subscriber-group/validate';
import styles from './merge-subscriber-group-modal.scss';

export class MergeSubscriberGroupModal extends Component<MergeSubscriberGroupProps> {

  public componentDidMount() {
    this.resetValidation();
  }

  private resetValidation = () => {
    this.props.resetValidation(fieldName);
  };

  public render() {

    const { className, mergeSubscriberGroup, options, validation, translation,
      onClose, loadOptions, updateMergeSubscriberGroup, deleteMergeSubscriberGroupItem } = this.props;

    const uncheckSelectItem = !this.props.mergeSubscriberGroup?.reassignReferencesToCode?.description;

    const handleOnLoadOptions = (loadOptionsParams: LoadOptions) => {
      loadOptions({
        ...(!!loadOptionsParams.query && {
          query: {
            text: loadOptionsParams.query
          }
        }),
        includeInactiveCodes: {
          enabled: !!loadOptionsParams.includeDisabled
        }
      });
    };

    const handleOnChange = (reassignReferencesToCode: CodeComplexValue<number>) => {
      this.resetValidation();
      updateMergeSubscriberGroup({ ...mergeSubscriberGroup, reassignReferencesToCode });
    };

    const handleClose = () => {
      onClose();
      this.resetValidation();
      updateMergeSubscriberGroup(undefined);
    };

    const onDone = () => {
      const currentValidation = validate({
        id: this.props.mergeSubscriberGroup?.id,
        reassignReferencesToCodeId: this.props.mergeSubscriberGroup?.reassignReferencesToCode?.value,
        translation: this.props.translation
      });

      if (currentValidation) {
        this.props.updateValidation(currentValidation);
        return;
      }

      deleteMergeSubscriberGroupItem(uncheckSelectItem);
    };

    return (<div className={className}>
      <ModalWrapper
        headerTitle={translation.delete_subscriber_group}
        btnTitle={translation.delete}
        btnCancelTitle={translation.cancel}
        onClose={handleClose}
        onDone={onDone}
        closeOnDone={false}
        isCancelDisabled={mergeSubscriberGroup?.fetching}
        isDisabled={mergeSubscriberGroup?.fetching}
        invertButtonOrder={true}>
        <div className="row">
          <div className="col-12">
            <p className={styles.multilineText}>
              {replaceTemplateString(
                translation.merge_subscriber_group_description,
                mergeSubscriberGroup.id,
                mergeSubscriberGroup.name
              )}
            </p>
            <p className="mt-4">
              {translation.merge_subscriber_group_sub_description}
            </p>
          </div>

          <MergeSubscriberGroupSinglePicker
            id={fieldName}
            label={undefined}
            size={12}
            valueItem={mergeSubscriberGroup?.[fieldName]}
            options={options}
            uncheckSelectItem={uncheckSelectItem}
            includeDisabledLabel={translation.include_disabled}
            readOnly={mergeSubscriberGroup?.fetching}
            translation={translation}
            validation={validation?.[fieldName]}
            onLoadOptions={handleOnLoadOptions}
            onChange={handleOnChange} />
        </div>
      </ModalWrapper>
    </div>);
  }
}
